import { defineComponent as _defineComponent } from 'vue';
import { SButton } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
import signUpImg1 from '@/assets/images/index/sign-up-img-1.png';
import signUpImg1x2 from '@/assets/images/index/sign-up-img-1@x2.png';
import signUpImg2 from '@/assets/images/index/sign-up-img-2.png';
import signUpImg2x2 from '@/assets/images/index/sign-up-img-2@x2.png';
import ResponsivePicture from '@/shared/ui/ResponsivePicture.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'LandingSignUpSection',
  setup: function setup(__props) {
    defineComponent({
      name: 'LandingSignUpSection'
    });
    return {
      __sfc: true,
      SButton: SButton,
      signUpImg1: signUpImg1,
      signUpImg1x2: signUpImg1x2,
      signUpImg2: signUpImg2,
      signUpImg2x2: signUpImg2x2,
      ResponsivePicture: ResponsivePicture
    };
  }
});